(() => {
  if (window.__glossaryHelperInitialized) {
    return;
  }
  window.__glossaryHelperInitialized = true;

  const defaultTerms = [
    {
      id: 'backset',
      term: 'Backset',
      definition:
        'The distance from the edge of the door to the centre of the handle spindle or keyhole; measure from the door edge to the centre of the pre-drilled hole.'
    }
  ];

  const normalizeTerm = (term = '') => term.toLowerCase();
  const defaultSelectors = ['[data-glossary-scan]', '.cart-barry-nudge__list', '.rte'];
  const userConfig = window.GlossaryHelperConfig || {};

  const mergedTerms = [...(userConfig.terms || []), ...defaultTerms].reduce((accumulator, entry) => {
    if (!entry || !entry.id || !entry.term) return accumulator;
    const hasMatch = accumulator.some(
      (existing) =>
        existing.id === entry.id || normalizeTerm(existing.term || '') === normalizeTerm(entry.term || '')
    );
    if (!hasMatch) {
      accumulator.push(entry);
    }
    return accumulator;
  }, []);
  const mergedSelectors = Array.from(new Set([...(userConfig.selectors || []), ...defaultSelectors]));
  const glossaryMap = new Map();
  mergedTerms
    .filter((entry) => entry && entry.id && entry.term)
    .forEach((entry) => {
      const normalized = normalizeTerm(entry.term);
      glossaryMap.set(entry.id, {
        id: entry.id,
        term: entry.term,
        title: entry.title || entry.term,
        definition: entry.definition || entry.description || ''
      });
      glossaryMap.set(normalized, glossaryMap.get(entry.id));
    });

  const modal = document.querySelector('[data-glossary-modal]');
  if (!modal) {
    return;
  }

  const dialog = modal.querySelector('.glossary-modal__dialog');
  const titleTarget = modal.querySelector('#GlossaryModalTitle');
  const bodyTarget = modal.querySelector('#GlossaryModalBody');
  const closeTargets = modal.querySelectorAll('[data-glossary-close]');

  dialog?.setAttribute('tabindex', '-1');

  const escapeRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const termLookup = {};
  const escapedTerms = [];
  glossaryMap.forEach((entry) => {
    if (!entry.term) return;
    const key = normalizeTerm(entry.term);
    if (!termLookup[key]) {
      termLookup[key] = entry.id;
      escapedTerms.push(escapeRegex(entry.term));
    }
  });

    const termRegex = escapedTerms.length ? new RegExp(`\\b(${escapedTerms.join('|')})\\b`, 'gi') : null;
    const skipSelector =
      'a, button, [data-glossary-id], .glossary-modal, h1, h2, h3, h4, h5, h6, [data-glossary-skip], script, style';

  const closeModal = () => {
    if (modal.hasAttribute('hidden')) return;
    modal.setAttribute('hidden', 'hidden');
    document.body.classList.remove('glossary-open');
  };

  const openModal = (glossaryId, trigger) => {
    const lookupKey = glossaryId && glossaryMap.get(glossaryId) ? glossaryId : normalizeTerm(glossaryId);
    const entry = glossaryMap.get(lookupKey) || glossaryMap.get(normalizeTerm(trigger?.textContent || ''));

    if (titleTarget) {
      titleTarget.textContent = entry?.title || trigger?.textContent?.trim() || glossaryId;
    }
    const definition =
      entry?.definition || trigger?.getAttribute?.('data-glossary-definition') || trigger?.dataset?.glossaryDefinition || '';

    if (bodyTarget) {
       bodyTarget.innerHTML = definition;
    }

    modal.removeAttribute('hidden');
    document.body.classList.add('glossary-open');
    dialog?.focus({ preventScroll: true });
  };

  closeTargets.forEach((target) => {
    target.addEventListener('click', (event) => {
      event.preventDefault();
      closeModal();
    });
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal || event.target?.hasAttribute?.('data-glossary-close')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  const createTrigger = (label, glossaryId) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'glossary-trigger';
    button.setAttribute('data-glossary-id', glossaryId);
    button.setAttribute('aria-haspopup', 'dialog');
    button.textContent = label;
    return button;
  };

  const wrapTextNode = (node) => {
    if (!termRegex || !node || !node.parentElement) return;

    if (node.parentElement.closest(skipSelector)) {
      return;
    }

    const text = node.nodeValue;
    if (!termRegex.test(text)) {
      return;
    }

    const fragments = text.split(termRegex);
    const fragment = document.createDocumentFragment();
    let hasMatch = false;

    fragments.forEach((part) => {
      if (!part) return;
      const lookupId = termLookup[normalizeTerm(part)];
      if (lookupId) {
        fragment.appendChild(createTrigger(part, lookupId));
        hasMatch = true;
      } else {
        fragment.appendChild(document.createTextNode(part));
      }
    });

    if (hasMatch) {
      node.parentElement.replaceChild(fragment, node);
    }
  };

  const scanContainer = (container) => {
    if (!container || container.dataset.glossaryProcessed === 'true') return;
    container.dataset.glossaryProcessed = 'true';

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        if (!node || !node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (!node.parentElement || node.parentElement.closest(skipSelector)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const textNodes = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach(wrapTextNode);
  };

  const scanAll = () => {
    mergedSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((container) => {
        scanContainer(container);
      });
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-glossary-id]');
    if (!trigger) return;

    event.preventDefault();
    openModal(trigger.getAttribute('data-glossary-id'), trigger);
  });

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    scanAll();
  });

  window.GlossaryHelper = {
    scanAll,
    addTerm: (entry) => {
      if (entry && entry.id && entry.term) {
        glossaryMap.set(entry.id, entry);
        termLookup[normalizeTerm(entry.term)] = entry.id;
      }
    },
    addSelector: (selector) => {
      if (selector && !mergedSelectors.includes(selector)) {
        mergedSelectors.push(selector);
      }
    }
  };
})();
